import {createSelector} from '@reduxjs/toolkit';

const getPositionManagementState = (state: any) =>
  state.positionManagementMaster;

const getShowTransferPartiesModal = createSelector(
  [getPositionManagementState],
  data => {
    return data?.showTransferPartiesModal;
  },
);

const getShowTransferAreasModal = createSelector(
  [getPositionManagementState],
  data => {
    return data?.showTransferAreasModal;
  },
);

const getAreaTransferType = createSelector(
  [getPositionManagementState],
  data => {
    return data?.areaTransferType;
  },
);

const getPartiesList = createSelector([getPositionManagementState], data => {
  const sortedArray = [...data?.partiesList]?.sort((a: any, b: any) => {
    if (a?.name < b?.name) {
      return -1;
    }
    if (a?.name > b?.name) {
      return 1;
    }
    return 0;
  });
  return sortedArray;
});

const getAreasList = createSelector([getPositionManagementState], data => {
  const sortedArray = [...data?.areasList]?.sort((a: any, b: any) => {
    if (a?.areaName < b?.areaName) {
      return -1;
    }
    if (a?.areaName > b?.areaName) {
      return 1;
    }
    return 0;
  });
  return sortedArray;
});

const getPartyDetails = createSelector([getPositionManagementState], data => {
  return data?.partyDetails;
});

const getPartiesSelectedForTransfer = createSelector(
  [getPositionManagementState],
  data => {
    return data?.partiesSelectedForTransfer;
  },
);

const getAreasSelectedForTransfer = createSelector(
  [getPositionManagementState],
  data => {
    return data?.areasSelectedForTransfer;
  },
);

const getCloningTimePeriod = createSelector(
  [getPositionManagementState],
  data => {
    return data?.cloningTimePeriod;
  },
);

const getPositionType = createSelector([getPositionManagementState], data => {
  return data?.positionType;
});

const getTransferPositionResponseType = createSelector(
  [getPositionManagementState],
  data => {
    return data?.transferPositionResponse;
  },
);

const getPositionCloneListGridOptions = createSelector(
  [getPositionManagementState],
  data => {
    return data?.positionCloneListGridOptions;
  },
);

const getPositionCloneListGridData = createSelector(
  [getPositionManagementState],
  data => {
    return data?.positionCloneListData;
  },
);

const getPositionCloneListRows = createSelector(
  [getPositionManagementState],
  data => {
    return data?.positionCloneListRows;
  },
);

const getClonePositionResponseType = createSelector(
  [getPositionManagementState],
  data => {
    return data?.clonePositionResponse;
  },
);

const getAllSelectedSelector = createSelector(
  [getPositionManagementState],
  data => {
    return data?.allSelected;
  },
);

const getPartiesFetchState = createSelector(
  [getPositionManagementState],
  data => {
    return data?.partiesFetched;
  },
);

const getAreasFetchState = createSelector(
  [getPositionManagementState],
  data => {
    return data?.areasFetched;
  },
);

const getCloningListResponse = createSelector(
  [getPositionManagementState],
  data => {
    return data?.cloningListResponse;
  },
);

const getPositionTransferListGridData = createSelector(
  [getPositionManagementState],
  data => {
    return data?.positionTransferListData;
  },
);

const getPositionTransferListRows = createSelector(
  [getPositionManagementState],
  data => {
    return data?.positionTransferListRows;
  },
);

const getPositionTransferListGridOptions = createSelector(
  [getPositionManagementState],
  data => {
    return data?.positionTransferListGridOptions;
  },
);

const getTransferListResponse = createSelector(
  [getPositionManagementState],
  data => {
    return data?.transferListResponse;
  },
);

const getValidateTransferResponse = createSelector(
  [getPositionManagementState],
  data => {
    return data?.validateTransferResponse;
  },
);

const getPartiesFilterOptions = createSelector(
  [getPositionManagementState],
  data => {
    return data?.partyFilterOptions;
  },
);

const getEffectiveDate = createSelector(
  [getPositionManagementState],
  data => {
    return data?.effectiveDate
  },
);

const getAreaAllocationResponse = createSelector(
  [getPositionManagementState],
  data => {
    return data?.areaAllocationResponse
  },
);

export const positionManagementSelector = {
  getShowTransferPartiesModal: () => getShowTransferPartiesModal,
  getShowTransferAreasModal: () => getShowTransferAreasModal,
  getAreaTransferType: () => getAreaTransferType,
  getPartiesList: () => getPartiesList,
  getAreasList: () => getAreasList,
  getPartyDetails: () => getPartyDetails,
  getPartiesSelectedForTransfer: () => getPartiesSelectedForTransfer,
  getAreasSelectedForTransfer: () => getAreasSelectedForTransfer,
  getCloningTimePeriod: () => getCloningTimePeriod,
  getPositionType: () => getPositionType,
  getTransferPositionResponse: () => getTransferPositionResponseType,
  getPositionCloneListGridOptions: () => getPositionCloneListGridOptions,
  getPositionCloneListGridData: () => getPositionCloneListGridData,
  getPositionCloneListRows: () => getPositionCloneListRows,
  getClonePositionResponse: () => getClonePositionResponseType,
  getAllSelected: () => getAllSelectedSelector,
  getPartiesFetchState: () => getPartiesFetchState,
  getAreasFetchState: () => getAreasFetchState,
  getCloningListResponse: () => getCloningListResponse,
  getPositionTransferListGridData: () => getPositionTransferListGridData,
  getPositionTransferListRows: () => getPositionTransferListRows,
  getPositionTransferListGridOptions: () => getPositionTransferListGridOptions,
  getTransferListResponse: () => getTransferListResponse,
  getValidateTransferResponse: () => getValidateTransferResponse,
  getPartiesFilterOptions: () => getPartiesFilterOptions,
  getEffectiveDate: () => getEffectiveDate,
  getAreaAllocationResponse: () => getAreaAllocationResponse,
};
